export const pageTitle = title => {
  return (document.title = title + ' | Medna Data Systems');
};
